<div *ngIf="text?.mayEdit" #textEditButton class="edit-button" >
    <button type="button"
            (click)="edit()"
            (mouseover)="mouseOver()"
            (mouseout)="mouseOut()"
            [matTooltip]="toolTip">
        <mat-icon class="material-icons-outlined">build_circle</mat-icon>
    </button>
</div>
<div *ngIf="doneLoading && text">
    <div [ngClass]="(this.over && text?.mayEdit ? 'text-container-edit padding-md' : text?.mayEdit && isEmpty ? 'padding-md' : '')" tabindex="0">
        <app-render-html [html]="text.interpolatedText"></app-render-html>
    </div>
</div>
